var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import useAuth from "../../App/hooks/useAuth";
import { customerEmployeeRole, customerRole } from "../../App/helpers/RoleHelper";
import { Can } from "../../App/utils/Authorize";
import CustomerService from "../services/CustomerService";
import { dateFormatter, documentFormatter } from "../../App/utils/formatter";
import { getGracePeriodEndDate, formatDateBR } from "../../App/utils/gracePeriod";
import { invalidateProvidersCache } from "../../App/hooks/useCustomerData";
import Title from "../../App/components/Title";
import Notification from "../../App/components/Notification";
import Impersonate from "../../App/components/Impersonate";
import { handleServiceError } from "../../App/components/ErrorHandler";
import "../../App/styles/Profile.css";
import "../../App/styles/App.css";
import Switch from '@mui/material/Switch';
import InfoIcon from "@mui/icons-material/Info";
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import ModalEmailIntegration from "./ModalEmailIntegration";
import Snackbar from '@mui/material/Snackbar';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import Overlay from "../../App/components/Overlay";
import BillingTab from "./Tabs/BillingTab";
import ResponsiblesTab from "./Tabs/ResponsiblesTab";
import IntegrationsTab from "./Tabs/IntegrationsTab";
import PlansTab from "./Tabs/PlanTab";
import { ServicesTab } from "./Tabs/ServicesTab";
import ProfileData from "./ProfileData";
import { setClarityTag } from "../../App/utils/clarity";
function Profile(props) {
    var _this = this;
    var _a, _b, _c;
    var auth = useAuth().auth;
    var _d = useForm(), handleSubmit = _d.handleSubmit, register = _d.register, reset = _d.reset;
    var _e = useState(props.customer), customer = _e[0], setCustomer = _e[1];
    var _f = useState([]), plans = _f[0], setPlans = _f[1];
    var _g = useState(), planId = _g[0], setPlanId = _g[1];
    var _h = useState([]), erps = _h[0], setErps = _h[1];
    var _j = useState(), erp = _j[0], setErp = _j[1];
    var _k = useState([]), hubs = _k[0], setHubs = _k[1];
    var _l = useState(), hubId = _l[0], setHubId = _l[1];
    var _m = useState([]), customersSuccess = _m[0], setCustomersSuccess = _m[1];
    var _o = useState(), customerSuccess = _o[0], setCustomerSuccess = _o[1];
    var _p = useState([]), closers = _p[0], setClosers = _p[1];
    var _q = useState(), closer = _q[0], setCloser = _q[1];
    var _r = useState([]), sellers = _r[0], setSellers = _r[1];
    var _s = useState(), seller = _s[0], setSeller = _s[1];
    var _t = useState(props.customer.support_phone), supportPhone = _t[0], setSupportPhone = _t[1];
    var _u = useState(props.customer.support_whatsapp), supportWhatsapp = _u[0], setSupportWhatsapp = _u[1];
    var navigate = useNavigate();
    var _v = useState(props.user), user = _v[0], setUser = _v[1];
    var _w = useState(props.user.email), editedMail = _w[0], setEditedEmail = _w[1];
    var _x = useState(props.user.email), originMail = _x[0], setOriginMail = _x[1];
    var _y = useState(props.customer.notify), notify = _y[0], setNotify = _y[1];
    var _z = useState(), token = _z[0], setToken = _z[1];
    var _0 = useState('password'), defaultGrant = _0[0], setDefaultGrant = _0[1];
    var _1 = useState(false), dataLoaded = _1[0], setDataLoaded = _1[1];
    var _2 = React.useState('faturamento'), tabValues = _2[0], setTabValues = _2[1];
    var _3 = useState(undefined), availableProductsBySupplier = _3[0], setAvailableProductsBySupplier = _3[1];
    var _4 = useState(), gracePeriods = _4[0], setGracePeriods = _4[1];
    var _5 = useState(false), showModalIntegration = _5[0], setShowModalIntegration = _5[1];
    var _6 = useState(), customerStatus = _6[0], setCustomerStatus = _6[1];
    var _7 = useState(false), isButtonDisabled = _7[0], setIsButtonDisabled = _7[1];
    var _8 = useState({}), hubStar = _8[0], setHubStar = _8[1];
    var _9 = useState({}), hubVip = _9[0], setHubVip = _9[1];
    var _10 = useState(false), hasChanges = _10[0], setHasChanges = _10[1];
    var _11 = useState(false), discardChanges = _11[0], setDiscardChanges = _11[1];
    var _12 = useState(false), shakeSnackBar = _12[0], setShakeSnackBar = _12[1];
    var _13 = useState(false), openSnackBar = _13[0], setOpenSnackbar = _13[1];
    var _14 = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    }), snackBarState = _14[0], setSnackBarState = _14[1];
    var handleOpenSnackBar = function () {
        setSnackBarState(__assign(__assign({}, snackBarState), { open: true }));
        setOpenSnackbar(true);
    };
    var handleCloseSnackBar = function () {
        setSnackBarState(__assign(__assign({}, snackBarState), { open: false }));
        setOpenSnackbar(false);
    };
    var handleOverlayClick = function () {
        setShakeSnackBar(true);
        setTimeout(function () {
            setShakeSnackBar(false);
        }, 500);
    };
    var handleDiscard = function () {
        var _a;
        setClarityTag("actionType", "profile-discard-changes-click");
        var originalValues = {
            name: customer.name,
            soft_cap: customer.soft_cap,
            billing_email: customer.billing_email,
            total_subscribers_base: customer.total_subscribers_base,
            support_mail: customer.support_mail,
            support_phone: supportPhone,
            support_whatsapp: supportWhatsapp,
            plan_id: planId,
            erp_id: erp ? erp.id : null,
            hub_id: hubId === 0 ? null : hubId,
            erp_data: erp,
            customer_success: customerSuccess,
            closer: closer,
            seller: seller,
            document: customer.document,
            editedMail: editedMail,
            originMail: originMail,
            notify: notify,
        };
        setSupportPhone(customer === null || customer === void 0 ? void 0 : customer.support_phone);
        setSupportWhatsapp(customer === null || customer === void 0 ? void 0 : customer.support_whatsapp);
        setPlanId(customer === null || customer === void 0 ? void 0 : customer.plan_id);
        setErp(customer === null || customer === void 0 ? void 0 : customer.erp_data);
        setHubId((_a = customer.hub) === null || _a === void 0 ? void 0 : _a.id);
        setCustomerSuccess(customer === null || customer === void 0 ? void 0 : customer.customer_success);
        setCloser(customer === null || customer === void 0 ? void 0 : customer.closer);
        setSeller(customer === null || customer === void 0 ? void 0 : customer.seller);
        setEditedEmail(props.user.email);
        setOriginMail(props.user.email);
        setNotify(customer === null || customer === void 0 ? void 0 : customer.notify);
        setHasChanges(false);
        props.providerData(customer.id.toString());
        reset(originalValues);
        setDiscardChanges(true);
        Notification().Notify.success("Alterações descartadas com sucesso!");
    };
    var params = useParams();
    var userId = params.id;
    useEffect(function () {
        var _a, _b;
        setCustomer(props.customer);
        setPlanId((_a = props.customer.plan) === null || _a === void 0 ? void 0 : _a.id);
        setErp(props.customer.erp_data);
        setHubId((_b = props.customer.hub) === null || _b === void 0 ? void 0 : _b.id);
        setCustomerSuccess(props.customer.customer_success);
        setCloser(props.customer.closer);
        setSeller(props.customer.seller);
        setUser(props.user);
    }, [props.customer]);
    useEffect(function () {
        var plansName = ['COMUNIDADE ISPs - HUB STAR', 'COMUNIDADE ISPs - HUB VIP'];
        var result = plans.filter(function (item) { return plansName.includes(item.name); });
        var hubStarPlan = result.find(function (item) { return item.name === 'COMUNIDADE ISPs - HUB STAR'; });
        var hubVipPlan = result.find(function (item) { return item.name === 'COMUNIDADE ISPs - HUB VIP'; });
        var hubStarInfo = hubStarPlan ? { name: hubStarPlan.name, plan_number: hubStarPlan === null || hubStarPlan === void 0 ? void 0 : hubStarPlan.plan_number, id: hubStarPlan.id } : {};
        var hubVipInfo = hubVipPlan ? { name: hubVipPlan.name, plan_number: hubVipPlan === null || hubVipPlan === void 0 ? void 0 : hubVipPlan.plan_number, id: hubVipPlan.id } : {};
        setHubStar(hubStarInfo);
        setHubVip(hubVipInfo);
    }, [plans]);
    useEffect(function () {
        getAllGracePeriods();
        customerStatusInformation();
    }, []);
    useEffect(function () {
        if (tabValues === "serviços") {
            getAvailableProductsBySupplier(customer.id);
        }
    }, [tabValues]);
    useEffect(function () {
        setClarityTag("pageSection", "profile-main");
    }, []);
    function getAvailableProductsBySupplier(customerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                CustomerService.getAvailableProductsBySupplier(customerId).then(function (res) {
                    Notification().Loading.remove();
                    var result = res.data.products_by_supplier;
                    setAvailableProductsBySupplier(result);
                }, function (err) {
                    Notification().Notify.failure(err.message);
                });
                return [2 /*return*/];
            });
        });
    }
    var handleToggleCustomerProduct = useCallback(function (product_id) {
        Notification().Confirm.show("Confirmar alteração", "Tem certeza que deseja fazer essa alteração? Essa ação pode afetar a cobrança recorrente.", "Confirmar", "Cancelar", function () {
            Notification().Loading.dots("Carregando...");
            toggleCustomerProduct(customer.id, product_id);
        });
    }, [customer.id]);
    function toggleCustomerProduct(customer_id, product_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                CustomerService.handleProduct({ customer_id: customer_id, product_id: product_id }).then(function (res) {
                    Notification().Notify.success(res.data.success);
                    getAvailableProductsBySupplier(customer_id);
                }, function (err) {
                    if (err.response.status === 403) {
                        Notification().Notify.failure("Usuário não tem permissão para executar essa ação!");
                    }
                    else {
                        Notification().Notify.failure(err.response.data.error);
                    }
                    Notification().Loading.remove();
                });
                return [2 /*return*/];
            });
        });
    }
    ;
    function changePlans(customerId, planId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Loading.dots("Carregando");
                CustomerService.changePlan(customerId, planId)
                    .then(function (res) {
                    Notification().Notify.success(res.data.success);
                    Notification().Loading.remove();
                }, function (err) {
                    var _a, _b;
                    if ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) {
                        Notification().Notify.failure(err.response.data.error);
                    }
                    Notification().Loading.remove();
                });
                return [2 /*return*/];
            });
        });
    }
    ;
    var handleSelectChange = function (event) {
        var selectedPlanId = event.target.value;
        setPlanId(Number(selectedPlanId));
    };
    function getAllGracePeriods() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CustomerService.getAllGracePeriods()
                            .then(function (res) {
                            setGracePeriods(res.data.grace_periods);
                        }, function (err) {
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function changeGracePeriod(data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CustomerService.changeGracePeriod(data)
                            .then(function (res) {
                            Notification().Notify.success(res.data.success);
                            // Sincroniza o estado local para o FIM DO PERÍODO recalcular sem refresh.
                            setCustomer(function (prev) { return (__assign(__assign({}, prev), { grace_period_id: data.grace_period_id })); });
                            invalidateProvidersCache();
                        })
                            .catch(function (err) {
                            var _a, _b;
                            if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) {
                                Notification().Notify.failure(err.response.data.error);
                            }
                            else {
                                Notification().Notify.failure('Ocorreu um erro ao trocar a data de carência.');
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    useEffect(function () {
        var handleData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, plansResponse, hubsResponse, erpsResponse, customersSuccessResponse, closersResponse, sellersResponse, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!dataLoaded) return [3 /*break*/, 5];
                        Notification().Block.circle("[data-id=profile-container");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all([CustomerService.getPlansWithProductsMinimum(customer.id), CustomerService.getAllHubs(), CustomerService.getAllErps(), CustomerService.getAllCustomersSuccess(), CustomerService.getAllClosers(), CustomerService.getAllSellers(),])];
                    case 2:
                        _a = _b.sent(), plansResponse = _a[0], hubsResponse = _a[1], erpsResponse = _a[2], customersSuccessResponse = _a[3], closersResponse = _a[4], sellersResponse = _a[5];
                        setPlans(plansResponse.data.plans);
                        setHubs(hubsResponse.data.hubs);
                        setErps(erpsResponse.data.erps);
                        setCustomersSuccess(customersSuccessResponse.data.customersSuccess);
                        setClosers(closersResponse.data.closers);
                        setSellers(sellersResponse.data.sellers);
                        setDataLoaded(true);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        handleServiceError(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        Notification().Block.remove("[data-id=profile-container]");
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        handleData();
    }, [auth.role_id, customerRole, customerEmployeeRole, dataLoaded]);
    function handleInputChange(event, type, index, openSnackBar) {
        if (openSnackBar === void 0) { openSnackBar = true; }
        switch (type) {
            case 'supportPhone':
                setSupportPhone(event.target.value);
                break;
            case 'supportWhatsapp':
                setSupportWhatsapp(event.target.value);
                break;
            case 'customerSuccess':
                setCustomerSuccess(customersSuccess === null || customersSuccess === void 0 ? void 0 : customersSuccess.find(function (customerSuccess) { return customerSuccess.id === Number(event.target.value); }));
                break;
            case 'closer':
                setCloser(closers === null || closers === void 0 ? void 0 : closers.find(function (closer) { return closer.id === Number(event.target.value); }));
                break;
            case 'seller':
                setSeller(sellers === null || sellers === void 0 ? void 0 : sellers.find(function (seller) { return seller.id === Number(event.target.value); }));
                break;
            case 'plan':
                setPlanId(Number(event.target.value));
                break;
            case 'editEmail':
                setEditedEmail(event.target.value);
                break;
            case 'toggleCustomerProduct':
                setNotify(function (prevNotify) { return !prevNotify; });
                var updatedCustomer = __assign({}, customer);
                updatedCustomer.notify = !customer.notify;
                updatedCustomer.editedMail = editedMail;
                updatedCustomer.originMail = originMail;
                props.callbackAction(updatedCustomer);
                break;
            case 'hub':
                setHubId(Number(event.target.value));
                break;
            case 'erp':
                if (customer.erp_id === Number(event.target.value)) {
                    setErp(customer.erp_data);
                }
                else {
                    setErp(erps.find(function (erp) { return erp.id === Number(event.target.value); }));
                }
                break;
            case 'erpFields':
                if (erp && erp.erp_fields) {
                    var updatedErp = __assign({}, erp);
                    updatedErp.erp_fields[index].value = event.target.value;
                    setErp(updatedErp);
                }
                break;
            case 'name':
            case 'billing_email':
            case 'soft_cap':
            case 'total_subscribers_base':
                setHasChanges(true);
                break;
            default:
                break;
        }
        setHasChanges(true);
        if (openSnackBar) {
            handleOpenSnackBar();
        }
    }
    ;
    function fetchHubs() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CustomerService.getAllHubs()
                            .then(function (res) {
                            setHubs(res.data.hubs);
                        }, function (error) {
                            handleServiceError(error);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    useEffect(function () {
        if (token) {
            if (erp && erp.erp_fields) {
                var updated_erp = __assign({}, erp);
                var tokenFieldIndex = updated_erp.erp_fields.findIndex(function (field) { return field.name === "Token"; });
                if (tokenFieldIndex !== -1) {
                    updated_erp.erp_fields[tokenFieldIndex].value = token;
                    setErp(updated_erp);
                }
            }
        }
    }, [token]);
    function generateToken() {
        var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
        var b = [];
        var length = 32;
        for (var i = 0; i < length; i++) {
            var j = parseInt((Math.random() * (a.length - 1)).toFixed(0), 10);
            b[i] = a[j];
        }
        var token = (b.join(""));
        setToken(token);
        navigator.clipboard.writeText(token).then(function () { Notification().Notify.success("Token copiado com sucesso!"); })
            .catch(function (err) { Notification().Notify.failure("Erro ao copiar o token!"); });
    }
    ;
    useEffect(function () {
        if (erp && erp.erp_fields && erp.erp_fields[5] && erp.erp_fields[5].value !== defaultGrant) {
            var updated_erp = __assign({}, erp);
            var grantTypeFieldIndex = updated_erp.erp_fields.findIndex(function (field) { return field.name === "GRANT_TYPE"; });
            if (grantTypeFieldIndex === 5) {
                updated_erp.erp_fields[grantTypeFieldIndex].value = defaultGrant;
                setErp(updated_erp);
            }
        }
    }, [erp]);
    function updateCustomer(formData) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedCustomer, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setClarityTag("actionType", "profile-save-changes-click");
                        if (discardChanges) {
                            setDiscardChanges(false);
                            return [2 /*return*/];
                        }
                        updatedCustomer = __assign({}, customer);
                        updatedCustomer.name = formData.name;
                        updatedCustomer.soft_cap = formData.soft_cap;
                        updatedCustomer.billing_email = formData.billing_email;
                        updatedCustomer.total_subscribers_base = formData.total_subscribers_base;
                        updatedCustomer.support_mail = formData.support_mail;
                        updatedCustomer.support_phone = supportPhone;
                        updatedCustomer.support_whatsapp = supportWhatsapp;
                        updatedCustomer.plan_id = planId;
                        updatedCustomer.erp_id = erp ? erp.id : null;
                        updatedCustomer.hub_id = hubId === 0 ? null : hubId;
                        updatedCustomer.erp_data = erp;
                        updatedCustomer.customer_success = customerSuccess;
                        updatedCustomer.closer = closer;
                        updatedCustomer.seller = seller;
                        updatedCustomer.document = customer.document;
                        updatedCustomer.editedMail = editedMail;
                        updatedCustomer.originMail = originMail;
                        updatedCustomer.notify = notify;
                        Notification().Loading.dots("Carregando");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, props.callbackAction(updatedCustomer)];
                    case 2:
                        _a.sent();
                        setSnackBarState(__assign(__assign({}, snackBarState), { open: false }));
                        setOpenSnackbar(false);
                        setCustomer(updatedCustomer);
                        setHasChanges(false);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        handleServiceError(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    ;
    function notifyCustomer(formData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Confirm.show("Confirmar alteração", "Tem certeza que deseja fazer essa alteração? Você não receberá mais e-mails quando um cliente for ativado.", "Confirmar", "Cancelar", function () {
                    handleInputChange({ target: { checked: !customer.notify } }, 'toggleCustomerProduct', undefined, false);
                });
                return [2 /*return*/];
            });
        });
    }
    ;
    function changeData() {
        setClarityTag("actionType", "profile-edit-data-click");
        navigate("/profile/user/".concat(user.id, "/update/"), {
            state: { user: user }
        });
    }
    ;
    function dissolution(customer_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                CustomerService.sendDissolution({ customer_id: customer_id }).then(function (res) {
                    Notification().Notify.success(res.data.success);
                }, function (error) {
                    handleServiceError(error);
                });
                return [2 /*return*/];
            });
        });
    }
    ;
    function sendDissolution(customer_id) {
        return __awaiter(this, void 0, void 0, function () {
            var msg;
            return __generator(this, function (_a) {
                msg = "Ao solicitar o distrato do provedor, todos os tokens serão cancelados e o contrato será enviado para o cliente. Deseja continuar?";
                Notification().Confirm.show("ATENÇÃO", msg, "Sim", "Não", function () {
                    dissolution(customer_id);
                });
                return [2 /*return*/];
            });
        });
    }
    ;
    var handleChangeTabs = function (event, newValue) {
        setClarityTag("actionType", "profile-tab-change-".concat(newValue));
        setTabValues(newValue);
    };
    var endOfPeriod = gracePeriods && Object.values(gracePeriods).length > 0 ? Number((_a = Object.values(gracePeriods).find(function (item) {
        return item.id === customer.grace_period_id;
    })) === null || _a === void 0 ? void 0 : _a.days) : undefined;
    var endOfPeriodDate = getGracePeriodEndDate(customer.grace_period_date, endOfPeriod);
    var formattedEndOfPeriodDate = endOfPeriodDate ? formatDateBR(endOfPeriodDate) : '';
    function sendCustomerToHomologation() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var res, err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        Notification().Loading.dots("Carregando...");
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, CustomerService.sendCustomerToHomologation(customer.id)];
                    case 2:
                        res = _c.sent();
                        Notification().Notify.success(res.data.success.message);
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _c.sent();
                        if ((_b = (_a = err_2 === null || err_2 === void 0 ? void 0 : err_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) {
                            Notification().Notify.failure(err_2.response.data.error);
                        }
                        else {
                            Notification().Notify.failure("Erro ao enviar cliente para homologação.");
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        Notification().Loading.remove();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    ;
    function customerStatusInformation() {
        var _a;
        var customerStatus = (_a = props.status) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === customer.customer_status_id; });
        if (customerStatus) {
            var result = {
                iconColor: customerStatus.icon_color,
                statusTranslation: customerStatus.customer_status_translation
            };
            setCustomerStatus(result);
        }
    }
    ;
    var action = (_jsxs(_Fragment, { children: [_jsx("button", __assign({ id: "btn-profile-discard-changes", onClick: function () { handleDiscard(); handleCloseSnackBar(); }, className: "discard-changes-button" }, { children: "Descartar" })), _jsx("button", __assign({ id: "btn-profile-save-changes", onClick: function () { handleSubmit(updateCustomer); handleCloseSnackBar(); }, className: "save-changes-button blue-button" }, { children: "Salvar" }))] }));
    var gracePeriodLabel = "Nenhuma data base de carência";
    if (customer.grace_period_date === undefined) {
        gracePeriodLabel = "Sem data";
    }
    else if (customer.grace_period_date !== null) {
        gracePeriodLabel = "Data base: ".concat(dateFormatter(customer.grace_period_date));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsx(Title, { text: "Dados do Provedor", hr: true }), _jsx(Can, __assign({ permission: "update-customer" }, { children: _jsxs("div", __assign({ className: "container-actions-provider" }, { children: [_jsxs("div", { children: [_jsx(Switch, { checked: Boolean(notify), onChange: notifyCustomer, color: "success" }), _jsx("span", { children: "Notifica\u00E7\u00F5es por e-mail" })] }), _jsx(Can, __assign({ permission: "impersonate-customer" }, { children: hasChanges === true ? (_jsx(Impersonate, { customerId: (_b = props.customer) === null || _b === void 0 ? void 0 : _b.id, disabled: true })) : (_jsx(Impersonate, { customerId: (_c = props.customer) === null || _c === void 0 ? void 0 : _c.id })) }))] })) })), _jsxs("form", __assign({ onSubmit: handleSubmit(updateCustomer), "data-id": "profile-container" }, { children: [(auth.role_id === customerRole || auth.role_id === customerEmployeeRole) && (_jsxs("div", __assign({ className: "container-actions-provider" }, { children: [_jsxs("div", __assign({ className: "d-flex align-items-center justify-content-center gap-2" }, { children: [_jsx(InfoIcon, { style: { color: "#003682" } }), _jsx("p", __assign({ className: "m-0" }, { children: "Caso haja erro ou necessidade de alterar seus dados de cobran\u00E7a, entre em contato com o seu CS." }))] })), _jsx(Can, __assign({ permission: "update-userProfile" }, { children: _jsx("div", { children: _jsx("button", __assign({ id: "btn-profile-edit-data", className: "btn-edit-data-profile blue-button ", onClick: function () { return changeData(); } }, { children: "Editar dados" })) }) }))] }))), _jsxs("div", __assign({ className: "container-profile-data" }, { children: [_jsx(ProfileData, { auth: auth, customer: customer, user: user, customerStatus: customerStatus, handleSubmit: handleSubmit, updateCustomer: updateCustomer, handleInputChange: handleInputChange, register: register, handleOpenSnackBar: handleOpenSnackBar, originMail: originMail, editedMail: editedMail, sendDissolution: sendDissolution }), _jsx("div", { children: _jsxs("div", __assign({ className: "data-profile-provider-infos-tabs" }, { children: [_jsxs(Tabs, __assign({ value: tabValues, onChange: handleChangeTabs, textColor: "secondary", "aria-label": "secondary tabs example", sx: { borderBottom: 1, borderColor: 'divider', '& .MuiTab-root': { fontFamily: "Gabarito" } } }, { children: [_jsx(Tab, { value: "faturamento", label: "Faturamento" }), _jsx(Tab, { value: "respons\u00E1veis", label: "Respons\u00E1veis" }), _jsx(Tab, { value: "integra\u00E7\u00F5es", label: "Integra\u00E7\u00F5es" }), _jsx(Tab, { value: "plano", label: "Plano" }), auth.role_id !== customerRole && auth.role_id !== customerEmployeeRole &&
                                                            _jsx(Tab, { value: "servi\u00E7os", label: "Servi\u00E7os" })] })), _jsxs("div", __assign({ className: "container-tab-infos" }, { children: [tabValues === "faturamento" && _jsx(BillingTab, { customer: customer, documentFormatter: documentFormatter }), tabValues === "responsáveis" && _jsx(ResponsiblesTab, { customer: customer, customersSuccess: customersSuccess, closers: closers, sellers: sellers, auth: auth, handleInputChange: handleInputChange, handleOpenSnackBar: handleOpenSnackBar, customerSuccess: customerSuccess, closer: closer, seller: seller }), tabValues === "integrações" && (_jsx(IntegrationsTab, { auth: auth, customer: customer, hubs: hubs, erps: erps, handleInputChange: handleInputChange, handleSubmit: handleSubmit, updateCustomer: updateCustomer, handleOpenSnackBar: handleOpenSnackBar, generateToken: generateToken, sendCustomerToHomologation: sendCustomerToHomologation, setShowModalIntegration: setShowModalIntegration, token: token, hubId: hubId, defaultGrant: defaultGrant, isButtonDisabled: isButtonDisabled, erp: erp })), tabValues === "plano" && (_jsx(PlansTab, { auth: auth, plans: plans, planId: planId, handleSelectChange: handleSelectChange, customer: customer, gracePeriodLabel: gracePeriodLabel, gracePeriods: gracePeriods, userId: userId, changeGracePeriod: changeGracePeriod, endOfPeriod: endOfPeriod, formattedEndOfPeriodDate: formattedEndOfPeriodDate, hubStar: hubStar, hubVip: hubVip, changePlans: changePlans })), (auth.role_id !== customerRole && auth.role_id !== customerEmployeeRole) && tabValues === "serviços" && (_jsx(ServicesTab, { availableProductsBySupplier: availableProductsBySupplier, handleToggleCustomerProduct: handleToggleCustomerProduct }))] }))] })) })] })), _jsx(Snackbar, { anchorOrigin: { vertical: snackBarState.vertical, horizontal: snackBarState.horizontal, }, open: snackBarState.open, className: shakeSnackBar ? 'snackbar-shake' : '', message: _jsxs(_Fragment, { children: [_jsx(PriorityHighIcon, { sx: { marginRight: 1, color: "#FFB400" } }), "Altera\u00E7\u00F5es foram feitas. Deseja salv\u00E1-las?"] }), action: action, sx: { zIndex: 9999999, fontFamily: 'Outfit, sans-serif' } }, snackBarState.vertical + snackBarState.horizontal), _jsx(Overlay, { isOpen: openSnackBar, onClose: handleCloseSnackBar, onClick: handleOverlayClick })] }))] })), _jsx(ModalEmailIntegration, { show: showModalIntegration, closeModal: function () { return setShowModalIntegration(false); }, customerId: customer.id, email: user.email, fetchHubs: fetchHubs, user: user, customer: customer, setIsButtonDisabled: setIsButtonDisabled, providerData: props.providerData })] }));
}
export default Profile;
